// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flash[data-v-38f5db65]{position:fixed;top:70px;width:100%;z-index:498}.flash__inner[data-v-38f5db65]{display:flex;flex-direction:column-reverse}@media only screen and (min-width:800px){.flash[data-v-38f5db65]{top:80px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
